/**
 * Three items, all 필수. PIPA wants 수집·이용 and 제3자 제공 consented separately, and
 * v1.1 bundled all of it behind one checkbox.
 *
 * ponytail: all three required means one stored `eula_version` string is a sufficient
 * record — the version identifies the bundle that itemizes them. If a 선택 item is ever
 * added, that stops being true and this needs a per-item consent record.
 */
export const CONSENTS = [
  { key: 'terms', required: true, label: '(필수) 이용약관에 동의합니다.' },
  {
    key: 'collection',
    required: true,
    label: '(필수) 개인정보 수집·이용에 동의합니다. (음성 데이터, 웹캠 스냅샷 이미지 포함)',
  },
  {
    key: 'thirdParty',
    required: true,
    label:
      '(필수) 학습·평가 내역, 웹캠 스냅샷 이미지, 역할극 음성 녹음의 제3자 제공에 동의합니다. (Apple 교육팀, 소속 파트너사 관리자)',
  },
];

export const allConsented = (checked) => CONSENTS.every((c) => checked[c.key] === true);
